import { defineMessages } from 'react-intl';

export const menuCategoriesGridProductCardLinkMessages = defineMessages({
  a11yLabel: {
    defaultMessage: 'Navigate to "{product_name}" product details screen',
    description: 'Menu | Categories grid | Product | Link a11y label',
  },
});
